import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridModule, DxToastModule } from 'devextreme-angular';
import { ConfigService } from 'src/app/services/config.service';
import { AppGlobals } from 'src/app/app.globals';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-config-dashboard.page',
    imports: [CommonModule, DxDataGridModule, DxButtonModule, DxToastModule],
    templateUrl: './config-dashboard.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./config-dashboard.page.css']
})
export class ConfigDashboardPageComponent implements OnInit {

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  @ViewChild('dashboardConfigGrid') dashboardConfigGrid: any;

  dashboardConfig: any;
  newId = 0;

  types = [
    { id: 1, type: 'group' },
    { id: 2, type: 'text' },
    { id: 3, type: 'number' },
    { id: 4, type: 'Fortschritt' },
    { id: 5, type: 'Prozentual' }
  ];

  activeFilter: any;
  pageBreadCrumb: any = { text: $localize`Configuration/`, href: window.location.href, layer: 0 }

  constructor(private service: ConfigService, private appGlobals: AppGlobals) { }

  ngOnInit(): void {

/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(8);
/*     } else {
      this.appGlobals.SetGlobalMenuIndex(7);
    } */

    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
    this.service.getDashboardConfig({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.dashboardConfig = result.configItems;
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  getNewId() {
    this.newId -= 1;
    return this.newId;
  }

  filterPe(e) {
    this.dashboardConfigGrid.instance.filter(["pe", "=", true]);
    this.activeFilter = "pe";
    this.dashboardConfigGrid.instance.refresh();
  }

  filterPa(e) {
    this.dashboardConfigGrid.instance.filter(["pa", "=", true]);
    this.activeFilter = "pa";
    this.dashboardConfigGrid.instance.refresh();
  }

  removeFilters(e) {
    this.dashboardConfigGrid.instance.clearFilter();
  }

  addNewRow(e) {
    this.dashboardConfigGrid.instance.closeEditCell();
    let newRow = {
      id: this.getNewId(),
      title: null,
      type: null,
      condition: null,
      value: null,
      pe: false,
      pa: false,
    }

    if (this.activeFilter == "pe") {
      newRow.pe = true;
    }

    if (this.activeFilter == "pa") {
      newRow.pa = true;
    }

    this.dashboardConfig.push(newRow);
    this.dashboardConfigGrid.instance.refresh();

    setTimeout(() => {
      this.dashboardConfigGrid.instance.editCell(this.dashboardConfigGrid.instance.getVisibleRows().length - 1, 'title');
    }, 20);
  }

  deleteItem(e, itemToRemove) {
    let itemToRemoveIndex = this.dashboardConfig.findIndex(item => item == itemToRemove.key)

    this.dashboardConfig.splice(itemToRemoveIndex, 1);

    this.dashboardConfigGrid.instance.refresh();
  }

  saveChanges(e) {
    this.dashboardConfigGrid.instance.closeEditCell();
    let payload = this.dashboardConfig;

    this.service.writeDashboardConfig({ configItems: payload }).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if (this.type = 'success') {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }
}
